import React, { FC } from 'react'
import { testId } from '@lojinha/helpers'
import { AlertTag, AlertTagVariants, Stack } from '@lojinha/design-system'
import { t } from '../../../dictionary'

type Props = {
  allergenics?: string | null
}

export const AllergensInfo: FC<Props> = ({ allergenics }) => {
  return (
    <Stack margin="x8" {...testId('marketable-product-allergens-info')}>
      <AlertTag
        variant={AlertTagVariants.primary}
        content={t.allergenicsWarning}
      />
      {allergenics && (
        <AlertTag
          variant={AlertTagVariants.primary}
          content={t.allergenics(allergenics)}
          {...testId('allergens-info-alert')}
        />
      )}
    </Stack>
  )
}
